import React, { useState } from "react";
import { Button } from "react-bootstrap";
import swal from "sweetalert";
import { db } from "../../../firebase";
import { completeAnnualMaskSaleOrder } from "./annualMaskSaleOrder";
import { ANNUAL_MASK_STATUS, canAdministerAnnualMaskPurchase } from "./annualMaskPurchaseUtils";

const AnnualMaskCompleteButton = ({ caseItem, currentUser, disabled, onComplete, className = "ml-1 mb-1" }) => {
  const [saving, setSaving] = useState(false);
  if (!canAdministerAnnualMaskPurchase(currentUser) || !caseItem.saleOrderId ||
    (caseItem.status === ANNUAL_MASK_STATUS.ORDER_COMPLETED && caseItem.saleOrderStatus === "เสร็จสิ้น")) return null;
  const complete = async () => {
    if (saving || disabled) return;
    const confirmed = await swal({
      title: "Mark purchase as เสร็จสิ้น?",
      text: `This will complete this Annual Mask Purchase and set Sale Order ${caseItem.saleOrderReceiptNo || caseItem.saleOrderId} to เสร็จสิ้น.`,
      icon: "warning",
      buttons: true,
    });
    if (!confirmed) return;
    setSaving(true);
    try {
      const values = await completeAnnualMaskSaleOrder({ database: db, caseItem, currentUser });
      await onComplete(values);
    } catch (error) {
      await swal("Cannot complete purchase", error.message, "error");
    } finally {
      setSaving(false);
    }
  };
  return <Button size="sm" variant="success" className={className} disabled={disabled || saving} onClick={complete}>
    {saving ? "Saving…" : "Mark as เสร็จสิ้น"}
  </Button>;
};
export default AnnualMaskCompleteButton;
